import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import InputField from '../../../../components/InputField'
import {CardBrandType} from '../../constants'
import AddressFormWithControls from '../AddressFormWithControls'
import {inputStyles} from './contants'
import stripe from '../../stripe'
import _ from 'underscore'
import {DateFormat} from '../../../../date_format'

export default class CardDetailsForm extends TemplateView {

    constructor({
        fieldsChangeCallback,
        countriesList,
        toggleAddressFormCallback,
        setStripeFieldsValid,
    }) {
        super()

        this.params = {
            countriesList,
        }

        this.callbacks = {
            fieldsChangeCallback,
            toggleAddressFormCallback,
            setStripeFieldsValid,
        }

        this.state = {
            cardType: CardBrandType.NONE,
            cardNumber: '',
            holderName: '',
            expiredMonth: '',
            expiredYear: '',
            address: '',
            city: '',
            zip: '',
            country: '',
            state: '',
            countries: [],
            statesByCountry: {},
            disabled: false,
            isAddressFormOpen: false,
        }

        this._cardPaySystemData = [
            {
                type: CardBrandType.MASTERCARD,
                class: 'master',
            },
            {
                type: CardBrandType.VISA,
                class: 'visa'
            },
            {
                type: CardBrandType.AMERICAN_EXPRESS,
                class: 'amex'
            },
            {
                type: CardBrandType.OTHER,
                class: 'other'
            }
        ]

        this.onStatePropertyChanged('isAddressFormOpen', (isAddressFormOpen) => {
            this.addressFormWithControls.setState({
                isAddressFormOpen
            })
        })

        this.onStatePropertyChanged('cardBrand', (cardType) => {
            for (let item of this._cardPaySystemData) {
                this.cardBrandIcon.toggleClass(item.class, cardType === item.type)
            }
        })

        this.onStatePropertyChanged('disabled', (disabled) => {

            this.cardNumberField.setState({disabled})
            this.expirationField.setState({disabled})
            this.holderNameField.setState({disabled})
            this.find('.cardNumberInput').toggle(disabled)
            this.find('.expirationInput').toggle(disabled)

            this.cardNumberStripeContainer.toggle(!disabled)
            this.expirationInputStripeContainer.toggle(!disabled)
            this.cvcInputStripeContainer.toggle(!disabled)
            this.securityCodeContainer.toggle(!disabled)

            this.addressFormWithControls.setState({disabled})
        })

        this.onAnyStatePropertyChanged(
            [
                'address',
                'city',
                'zip',
                'country',
                'state',
                'countries',
                'statesByCountry'
            ], () => {
                this.addressFormWithControls.setState({
                    address: this.state.address,
                    city: this.state.city,
                    zip: this.state.zip,
                    country: this.state.country,
                    state: this.state.state,
                    countries: this.state.countries,
                    statesByCountry: this.state.statesByCountry,
                })
            })

        this.onStatePropertyChanged('cardNumber', (cardNumber) => {
            this.cardNumberField.setValue(messageResource.getMessage('licenses.panel.card_number', [cardNumber]))
        })

        this.onStatePropertyChanged('holderName', (holderName) => this._setValueIfChanged(this.holderNameField, holderName))

        this.onAnyStatePropertyChanged(['expiredMonth', 'expiredYear'], () => {
            this.expirationField.setValue(this.dateFormatter.formatDate(new Date(this.state.expiredYear, this.state.expiredMonth - 1)))
        })
    }

    templateHtml() {
        return `<div class="cardDetailsForm">
                    <div class="cardInfo">
                        <div class="cardNumberContainer field">
                            <div class="name"><%=cardNumberFieldName%></div>
                            <div class="cardBrandIcon"/>
                            <div class="cardNumberInput"/>
                            <div class="cardNumberStripe"/>
                        </div>
                        <div class="securityCodeContainer field">
                            <div class="name"><%=securityCodeFieldName%></div>
                            <div class="cvcInputStripe"/>
                        </div>
                        
                        <div class="holderNameContainer field">
                            <div class="name"><%=holderNameFieldName%></div>
                            <div class="holderNameInput"/>
                        </div>
                        <div class="expirationDateContainer field">
                            <div class="name"><%=expirationDateFieldName%></div>
                            <div class="dateInputsContainer">
                                <div class="expirationInput"/>
                                <div class="expirationInputStripe"/>
                            </div>
                        </div>
                    </div>
                    <div class="addressInfo"/>
                </div>`
    }

    messageKeys() {
        return {
            cardNumberFieldName: 'licenses.card_details.title.fields.card_number',
            securityCodeFieldName: 'licenses.card_details.title.fields.cvc',
            holderNameFieldName: 'licenses.card_details.title.fields.holder_name',
            expirationDateFieldName: 'licenses.card_details.title.fields.date',
        }
    }

    afterRender() {
        this._createStripeElements()

        this._createDisabledCardsForm()

        this.securityCodeContainer = this.find('.securityCodeContainer')
        this.cardBrandIcon = this.find('.cardBrandIcon')

        this.addressFormWithControls = new AddressFormWithControls({
            fieldsChangeCallback: this.callbacks.fieldsChangeCallback,
            toggleAddressFormCallback: this.callbacks.toggleAddressFormCallback,
            countriesList: this.params.countriesList,
        }).init(this.find('.addressInfo'))

        this.dateFormatter = new DateFormat('MM / yy')

        this.renderInitialState()
    }

    _createDisabledCardsForm() {
        this.holderNameField = new InputField({
            additionalClass: 'holderNameField',
            placeholder: messageResource.getMessage('licenses.card_details.placeholders.holder_name'),
            name: 'ccname',
            autocomplete: 'cc-name',
            disabled: true,
            maxLength: 255,
            onChange: (holderName) => this.callbacks.fieldsChangeCallback({holderName}),
        }).init(this.find('.holderNameInput'))

        this.cardNumberField = new InputField({
            additionalClass: 'cardNumberField',
            placeholder: 'XXXX XXXX XXXX XXXX',
            name: 'cardnumber',
            autocomplete: 'cc-number',
            disabled: true,
        }).init(this.find('.cardNumberInput'))

        this.expirationField = new InputField({
            placeholder: messageResource.getMessage('licenses.card_details.placeholders.month'),
            additionalClass: 'expirationDateField',
            name: 'ccmonth',
            autocomplete: 'cc-exp-month',
            disabled: true,
        }).init(this.find('.expirationInput'))
    }

    _createStripeElements() {
        this.stripeElements = stripe.elements()

        this.cardNumberStripeContainer = this.find('.cardNumberStripe')
        this.stripeCardNumber = this.stripeElements.create('cardNumber', inputStyles)
        this.stripeCardNumber.mount(this.cardNumberStripeContainer[0])

        this.expirationInputStripeContainer = this.find('.expirationInputStripe')
        this.stripeCardExpiry = this.stripeElements.create('cardExpiry', inputStyles)
        this.stripeCardExpiry.mount(this.expirationInputStripeContainer[0])

        this.cvcInputStripeContainer = this.find('.cvcInputStripe')
        this.stripeCardCvc = this.stripeElements.create('cardCvc', inputStyles)
        this.stripeCardCvc.mount(this.cvcInputStripeContainer[0])

        this.stripeCardNumber.on('focus', () => {
            this.cardNumberStripeContainer.toggleClass('focus', true)
        })

        this.stripeCardExpiry.on('focus', () => {
            this.expirationInputStripeContainer.toggleClass('focus', true)
        })

        this.stripeCardCvc.on('focus', () => {
            this.cvcInputStripeContainer.toggleClass('focus', true)
        })

        this.stripeCardNumber.on('blur', () => {
            this.cardNumberStripeContainer.toggleClass('focus', false)
        })
        this.stripeCardNumber.on('change', (e) => {
            this.callbacks.setStripeFieldsValid({cardNumber: e.complete})
        })

        this.stripeCardExpiry.on('blur', () => {
            this.expirationInputStripeContainer.toggleClass('focus', false)
        })
        this.stripeCardExpiry.on('change', (e) => {
            this.callbacks.setStripeFieldsValid({cardExpiry: e.complete})
        })

        this.stripeCardCvc.on('blur', () => {
            this.cvcInputStripeContainer.toggleClass('focus', false)
        })
        this.stripeCardCvc.on('change', (e) => {
            this.callbacks.setStripeFieldsValid({cardCvc: e.complete})
        })
    }

    getStripeElements() {
        return this.stripeCardNumber
    }

    clearStripeElements() {
        this.stripeCardNumber.clear()
        this.stripeCardExpiry.clear()
        this.stripeCardCvc.clear()
    }

    _setValueIfChanged(field, value) {
        if (field && field.getValue() != value) {
            field.setValue(_.escape(value))
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/creditCard/CardDetailsForm.js